import { Switch as BaseSwitch } from "@base-ui/react/switch";
import { cn } from "../lib/cn";

export interface SwitchProps extends Omit<BaseSwitch.Root.Props, "className"> {
  className?: string;
}

export function Switch({ className, ...props }: SwitchProps) {
  return (
    <BaseSwitch.Root
      data-slot="switch"
      className={cn(
        "inline-flex h-5 w-8 shrink-0 items-center rounded-full bg-border-strong p-0.5 transition-colors duration-fast focus-ring data-checked:bg-accent data-disabled:cursor-not-allowed data-disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <BaseSwitch.Thumb
        data-slot="switch-thumb"
        className="block size-4 rounded-full bg-white shadow-sm transition-transform duration-fast data-checked:translate-x-3"
      />
    </BaseSwitch.Root>
  );
}
